import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faUserShield,
  faUserGraduate,
  faUsers,
  faChalkboardTeacher,
  faBook,
  faLayerGroup,
  faCalendarAlt,
  faSignOutAlt,
  faHome,
  faSignInAlt,
  faBullhorn,
  faClock,
  faUserTimes,
  faEnvelope,
  faClipboardList,
  faChartBar,
  faClipboardCheck,
  faHistory,
  faIdCard,
  faPersonRifle,
  faDollarSign,
  faBalanceScale,
  faClipboard
} from '@fortawesome/free-solid-svg-icons';
import useAuth from '../../hooks/useAuth';
import Modal from 'react-modal';
import '../../assets/styles/NavigationLinks.css';

Modal.setAppElement('#root');

const NavigationLinks = ({ onLinkClick }) => {
  const { user, logoutUser } = useAuth();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleLogout = () => {
    logoutUser();
    closeModal();
    if (onLinkClick) onLinkClick();
  };

  const handleLinkClick = (path) => {
    if (onLinkClick) onLinkClick();
    navigate(path);
  };

  return (
    <>
      <ul>
        {user ? (
          <>
            {(user.role === 'admin' || user.role === 'super-admin') && (
              <>
                <li>
                  <Link className="links" to="/admin/dashboard" onClick={() => handleLinkClick('/admin/dashboard')}>
                    <FontAwesomeIcon icon={faTachometerAlt} className="fa-icon" /> Dashboard
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/grading-policy" onClick={() => handleLinkClick('/admin/grading-policy')}>
                    <FontAwesomeIcon icon={faClipboard} className="fa-icon" /> Manage Grading Policy
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/grading-scale" onClick={() => handleLinkClick('/admin/grading-scale')}>
                    <FontAwesomeIcon icon={faBalanceScale} className="fa-icon" /> Manage Grade Scale
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/library" onClick={() => handleLinkClick('/admin/library')}>
                    <FontAwesomeIcon icon={faBook} className="fa-icon" /> Manage Library
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/admins" onClick={() => handleLinkClick('/admin/admins')}>
                    <FontAwesomeIcon icon={faUserShield} className="fa-icon" /> Admins
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/admin/students" onClick={() => handleLinkClick('/admin/students')}>
                    <FontAwesomeIcon icon={faUserGraduate} className="fa-icon" /> Students
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/fees" onClick={() => handleLinkClick('/admin/fees')}>
                    <FontAwesomeIcon icon={faDollarSign} className="fa-icon" /> Fee
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/parents" onClick={() => handleLinkClick('/admin/parents')}>
                    <FontAwesomeIcon icon={faUsers} className="fa-icon" /> Parents
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/staff" onClick={() => handleLinkClick('/admin/staff')}>
                    <FontAwesomeIcon icon={faChalkboardTeacher} className="fa-icon" /> Staffs
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/teachers" onClick={() => handleLinkClick('/admin/teachers')}>
                    <FontAwesomeIcon icon={faChalkboardTeacher} className="fa-icon" /> Teachers
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/courses" onClick={() => handleLinkClick('/admin/courses')}>
                    <FontAwesomeIcon icon={faBook} className="fa-icon" /> Courses
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/gradelevels" onClick={() => handleLinkClick('/admin/gradelevels')}>
                    <FontAwesomeIcon icon={faLayerGroup} className="fa-icon" /> Grade Levels
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/academicyears" onClick={() => handleLinkClick('/admin/academicyears')}>
                    <FontAwesomeIcon icon={faCalendarAlt} className="fa-icon" /> Academic Years
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/student-cards" onClick={() => handleLinkClick('/admin/student-cards')}>
                    <FontAwesomeIcon icon={faIdCard} className="fa-icon" /> Student Cards
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/attendances" onClick={() => handleLinkClick('/admin/attendances')}>
                    <FontAwesomeIcon icon={faClipboardList} className="fa-icon" /> Attendances
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/notifications" onClick={() => handleLinkClick('/admin/notifications')}>
                    <FontAwesomeIcon icon={faEnvelope} className="fa-icon" /> Messages
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/announcements" onClick={() => handleLinkClick('/admin/announcements')}>
                    <FontAwesomeIcon icon={faBullhorn} className="fa-icon" /> Announcements
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/timetables" onClick={() => handleLinkClick('/admin/timetables')}>
                    <FontAwesomeIcon icon={faClock} className="fa-icon" /> Timetables
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/teacherhistories" onClick={() => handleLinkClick('/admin/teacherhistories')}>
                    <FontAwesomeIcon icon={faHistory} className="fa-icon" /> Teacher History
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/staffhistories" onClick={() => handleLinkClick('/admin/staffhistories')}>
                    <FontAwesomeIcon icon={faHistory} className="fa-icon" /> Staff History
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/admin/studenthistories" onClick={() => handleLinkClick('/admin/studenthistories')}>
                    <FontAwesomeIcon icon={faHistory} className="fa-icon" /> Student History
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/admin/resignations" onClick={() => handleLinkClick('/admin/resignations')}>
                    <FontAwesomeIcon icon={faUserTimes} className="fa-icon" /> Resigns
                  </Link>
                </li>
              </>
            )}
            {user.role === 'teacher' && (
              <>
                <li>
                  <Link className="links" to="/teacher/dashboard" onClick={() => handleLinkClick('/teacher/dashboard')}>
                    <FontAwesomeIcon icon={faTachometerAlt} className="fa-icon" /> Dashboard
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/teacher/courses" onClick={() => handleLinkClick('/teacher/courses')}>
                    <FontAwesomeIcon icon={faBook} className="fa-icon" /> My Courses
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/teacher/assessments" onClick={() => handleLinkClick('/teacher/assessments')}>
                    <FontAwesomeIcon icon={faBook} className="fa-icon" /> Assessments
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/teacher/grades" onClick={() => handleLinkClick('/teacher/grades')}>
                    <FontAwesomeIcon icon={faChartBar} className="fa-icon" /> Student Marks
                  </Link>
                </li>
                {/* <li>
                  <Link className="links" to="/teacher/students" onClick={() => handleLinkClick('/teacher/students')}>
                    <FontAwesomeIcon icon={faUserGraduate} className="fa-icon" /> My Students
                  </Link>
                </li> */}

                <li>
                  <Link className="links" to="/teacher/attendances" onClick={() => handleLinkClick('/teacher/attendances')}>
                    <FontAwesomeIcon icon={faClipboardList} className="fa-icon" /> Student Attendances
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/teacher/myattendances" onClick={() => handleLinkClick('/teacher/myattendances')}>
                    <FontAwesomeIcon icon={faClipboardList} className="fa-icon" /> My Attendances
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/teacher/notifications" onClick={() => handleLinkClick('/teacher/notifications')}>
                    <FontAwesomeIcon icon={faEnvelope} className="fa-icon" /> Messages
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/teacher/announcements" onClick={() => handleLinkClick('/teacher/announcements')}>
                    <FontAwesomeIcon icon={faBullhorn} className="fa-icon" /> Announcements
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/teacher/timetables" onClick={() => handleLinkClick('/teacher/timetables')}>
                    <FontAwesomeIcon icon={faClock} className="fa-icon" /> Timetables
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/teacher/histories" onClick={() => handleLinkClick('/teacher/histories')}>
                    <FontAwesomeIcon icon={faHistory} className="fa-icon" /> My History
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/teacher/resignations" onClick={() => handleLinkClick('/teacher/resignations')}>
                    <FontAwesomeIcon icon={faUserTimes} className="fa-icon" /> Resigns
                  </Link>
                </li>

              </>
            )}
            {user.role === 'student' && (
              <>
                <li>
                  <Link className="links" to="/student/dashboard" onClick={() => handleLinkClick('/student/dashboard')}>
                    <FontAwesomeIcon icon={faTachometerAlt} className="fa-icon" /> Dashboard
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/student/courses" onClick={() => handleLinkClick('/student/courses')}>
                    <FontAwesomeIcon icon={faBook} className="fa-icon" /> Courses
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/student/enrollments" onClick={() => handleLinkClick('/student/enrollments')}>
                    <FontAwesomeIcon icon={faBook} className="fa-icon" /> My Enrolled Courses
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/student/graderesults" onClick={() => handleLinkClick('/student/graderesults')}>
                    <FontAwesomeIcon icon={faClipboardCheck} className="fa-icon" /> Grade results
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/student/attendances" onClick={() => handleLinkClick('/student/attendances')}>
                    <FontAwesomeIcon icon={faClipboardList} className="fa-icon" /> Attendances
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/student/notifications" onClick={() => handleLinkClick('/student/notifications')}>
                    <FontAwesomeIcon icon={faEnvelope} className="fa-icon" /> Messages
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/student/announcements" onClick={() => handleLinkClick('/student/announcements')}>
                    <FontAwesomeIcon icon={faBullhorn} className="fa-icon" /> Announcements
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/student/timetables" onClick={() => handleLinkClick('/student/timetables')}>
                    <FontAwesomeIcon icon={faClock} className="fa-icon" /> Timetables
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/student/histories" onClick={() => handleLinkClick('/student/histories')}>
                    <FontAwesomeIcon icon={faHistory} className="fa-icon" /> My History
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/student/resignations" onClick={() => handleLinkClick('/student/resignations')}>
                    <FontAwesomeIcon icon={faUserTimes} className="fa-icon" /> Resigns
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/student/profile" onClick={() => handleLinkClick('/student/profile')}>
                    <FontAwesomeIcon icon={faPersonRifle} className="fa-icon" /> Profile
                  </Link>
                </li>

              </>
            )}
            {user.role === 'staff' && (
              <>
                <li>
                  <Link className="links" to="/staff/dashboard" onClick={() => handleLinkClick('/staff/dashboard')}>
                    <FontAwesomeIcon icon={faTachometerAlt} className="fa-icon" /> Dashboard
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/staff/library" onClick={() => handleLinkClick('/staff/library')}>
                    <FontAwesomeIcon icon={faBook} className="fa-icon" /> Manage Library
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/staff/students" onClick={() => handleLinkClick('/staff/students')}>
                    <FontAwesomeIcon icon={faUserGraduate} className="fa-icon" /> Students
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/staff/fees" onClick={() => handleLinkClick('/staff/fees')}>
                    <FontAwesomeIcon icon={faDollarSign} className="fa-icon" /> Fee
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/staff/parents" onClick={() => handleLinkClick('/staff/parents')}>
                    <FontAwesomeIcon icon={faUsers} className="fa-icon" /> Parents
                  </Link>
                </li>

                <li>
                  <Link className="links" to="/staff/student-cards" onClick={() => handleLinkClick('/staff/student-cards')}>
                    <FontAwesomeIcon icon={faIdCard} className="fa-icon" /> Student Cards
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/staff/attendances" onClick={() => handleLinkClick('/staff/attendances')}>
                    <FontAwesomeIcon icon={faClipboardList} className="fa-icon" /> My Attendances
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/staff/notifications" onClick={() => handleLinkClick('/staff/notifications')}>
                    <FontAwesomeIcon icon={faEnvelope} className="fa-icon" /> Messages
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/staff/announcements" onClick={() => handleLinkClick('/staff/announcements')}>
                    <FontAwesomeIcon icon={faBullhorn} className="fa-icon" /> Announcements
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/staff/timetables" onClick={() => handleLinkClick('/staff/timetables')}>
                    <FontAwesomeIcon icon={faClock} className="fa-icon" /> Timetables
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/staff/resignations" onClick={() => handleLinkClick('/staff/resignations')}>
                    <FontAwesomeIcon icon={faUserTimes} className="fa-icon" /> Resigns
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/staff/histories" onClick={() => handleLinkClick('/staff/histories')}>
                    <FontAwesomeIcon icon={faHistory} className="fa-icon" /> My History
                  </Link>
                </li>
              </>
            )}

            {(user.role === 'parent' || user.role === 'guardian') && (
              <>
                <li>
                  <Link className="links" to="/parent/dashboard" onClick={() => handleLinkClick('/parent/dashboard')}>
                    <FontAwesomeIcon icon={faTachometerAlt} className="fa-icon" /> Dashboard
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/parent/students" onClick={() => handleLinkClick('/parent/students')}>
                    <FontAwesomeIcon icon={faUserGraduate} className="fa-icon" /> My Students
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/parent/notifications" onClick={() => handleLinkClick('/parent/notifications')}>
                    <FontAwesomeIcon icon={faEnvelope} className="fa-icon" /> Messages
                  </Link>
                </li>
                <li>
                  <Link className="links" to="/parent/announcements" onClick={() => handleLinkClick('/parent/announcements')}>
                    <FontAwesomeIcon icon={faBullhorn} className="fa-icon" /> Announcements
                  </Link>
                </li>
              </>
            )}
            <li>
              <button onClick={openModal}>
                <FontAwesomeIcon icon={faSignOutAlt} className="fa-icon" /> Logout
              </button>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link className="links logout-button" to="/" onClick={() => handleLinkClick('/')}>
                <FontAwesomeIcon icon={faHome} className="fa-icon" /> Home
              </Link>
            </li>
            <li>
              <Link className="links" to="/login" onClick={() => handleLinkClick('/login')}>
                <FontAwesomeIcon icon={faSignInAlt} className="fa-icon" /> Login
              </Link>
            </li>
          </>
        )}
      </ul>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="modal-overlay"
      >
        <h2>Confirm Logout</h2>
        <p>Are you sure you want to logout?</p>
        <div className="modal-buttons">
          <button onClick={closeModal} className="cancel-button">Cancel</button>
          <button onClick={handleLogout} className="confirm-button">Logout</button>
        </div>
      </Modal>
    </>
  );
};

export default NavigationLinks;
